<template>
  <div class="sub-page">
    <van-nav-bar :title="$t('setting.language')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#c9a84c" size="20" @click="back()" />
      </template>
    </van-nav-bar>
    <div class="card items">
      <div
        class="item"
        @click="changeLang('kr', $event)"
      >
        <div class="flex_center">
          <div class="info">한국어</div>
        </div>
        <div v-if="lang == 'kr'" class="check">✓</div>
      </div>
    </div>
  </div>
</template>
  
  <script>


import { Toast } from "vant";
export default {
  name: "Language",
  data() {
    return {
      lang: this.$i18n.locale || "kr",
      source: ''
    };
  },
  created() {
    this.replaceLang()
  },
  mounted() {
    this.source=this.$route.params.type
  },
  methods: {
    back(){
      return window.history.back();
    },
    replaceLang() {
      this.$http({
        method: "get",
        url: "replaceLang",
        data: {
          lang: this.lang,
        },
      }).then((res) => {
      console.log(res,11)
      });
    },
    changeLang(lang) {
      
      Toast.loading({
        // mask: true,
        duration: 200,
      });
      this.lang = lang;
      this.$i18n.locale = lang;
      this.replaceLang()
      localStorage.setItem("lang", lang);
   
      if (this.source=='setting'){
        this.$router.push({path:'/'});
      }else{
        this.$router.go(-1);
      }
    },
    }

};
</script>

<style lang='less' scoped>
.sub-page{
  min-height: 100vh;
  background: #000000;
}
.card.items {
  background: #141414;
  border-radius: 16px;
  margin: 24px;
  font-size: 30px;
  color: #c9a84c;
  padding: 0 28px;
}
.card.items .item {
  padding: 34px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.check{
  color: #c9a84c;
  font-size: 34px;
  font-weight: 700;
}
.flex_center {
  display: flex;
  align-items: center;
}
</style>
